import { Controller } from "@hotwired/stimulus"

// A closer look's pictures: a thumbnail puts itself in the big box. One of
// the pictures alike (a merge card's figures side by side) puts each other
// card's copy of it in theirs too, so the two can be looked at together.
export default class extends Controller {
  show(event) {
    const thumb = event.currentTarget
    const step = thumb.dataset.rwPeekAlike
    const cards = step === undefined ? [ this.element ] : (this.element.closest("turbo-frame") || document).querySelectorAll("[data-rw-peek-card]")
    cards.forEach((card) => {
      const shown = step === undefined ? thumb : card.querySelector(`[data-rw-peek-alike="${step}"]`)
      const main = card.querySelector("[data-rw-peek-main]")
      // The thumbnail's big size (data-rw-peek-src), not the small one it shows.
      if (shown && main) main.src = shown.dataset.rwPeekSrc || shown.querySelector("img").src
    })
  }
}
